import React from 'react';
import { Skeleton } from '@material-ui/lab';

export const DateIndicator = () => <Skeleton width={84} />;
export const MainHeader = () => <Skeleton width={'25em'} />;
export const ActionIcon = () => (
  <Skeleton variant='circle' width={40} height={40} />
);
export const TimeSubHeader = () => <Skeleton width={70} />;
